var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c("x-header", {
        attrs: {
          color: "primary",
          isMenuOpen: _vm.menuOpen,
          "back-button": _vm.showBackButton,
        },
        on: {
          menuTriggerClick: function ($event) {
            _vm.menuOpen = !_vm.menuOpen
          },
          backButtonClick: _vm.backButton,
        },
        scopedSlots: _vm._u([
          {
            key: "middle",
            fn: function () {
              return [
                _c(
                  "router-link",
                  { staticClass: "logo", attrs: { to: _vm.dashboardLink } },
                  [
                    _c("span", [_vm._v("xTrade Casualty")]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: { src: "/assets/img/from-howden.svg" },
                    }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _vm.$root.usingAdvancedActivitiesFramework()
                  ? _c(
                      "x-btn",
                      { attrs: { flat: "" } },
                      [_c("my-tasks-icon")],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("navigation-overlay", {
        attrs: { menuOpen: _vm.menuOpen },
        on: { closeNav: _vm.closeNav },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }